import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanchTatvaButton from '../components/PanchTatvaButton';

export default function PaymentFailed() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-2xl mx-auto px-4 md:px-6 py-12 md:py-20">
      {/* Error Banner */}
      <div className="mb-12 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-red-100 mb-4">
          <svg
            className="w-8 h-8 md:w-10 md:h-10 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <h1 className="text-3xl md:text-4xl font-heading text-headingText mb-3">
          Payment Failed
        </h1>
        <p className="text-bodyText text-lg">
          Unfortunately, your payment could not be processed.
        </p>
      </div>

      {/* Content Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {/* Error Details */}
        <div className="bg-cardBg rounded-lg p-6 shadow-lg">
          <h2 className="text-xl font-heading text-headingText mb-4">What Happened?</h2>
          <ul className="space-y-3 text-sm text-bodyText">
            <li className="flex items-start gap-3">
              <span className="text-red-600 font-bold">•</span>
              <span>Your payment was not successfully processed</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-red-600 font-bold">•</span>
              <span>Your shopping cart has been saved</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-red-600 font-bold">•</span>
              <span>No charges have been made to your account</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-red-600 font-bold">•</span>
              <span>You can try again anytime</span>
            </li>
          </ul>
        </div>

        {/* Common Reasons */}
        <div className="bg-cardBg rounded-lg p-6 shadow-lg">
          <h2 className="text-xl font-heading text-headingText mb-4">Common Reasons</h2>
          <ul className="space-y-3 text-sm text-bodyText">
            <li className="flex items-start gap-3">
              <span className="text-secondary font-bold">✓</span>
              <span>Incorrect card details</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-secondary font-bold">✓</span>
              <span>Insufficient funds</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-secondary font-bold">✓</span>
              <span>Card declined by bank</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-secondary font-bold">✓</span>
              <span>Network connectivity issues</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Cart Preserved Notice */}
      <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg mb-12">
        <h3 className="font-semibold text-amber-900 mb-2">Your Cart Is Saved</h3>
        <p className="text-sm text-amber-800">
          Don't worry! Your items are still in your cart. You can proceed to checkout and try
          again at any time.
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <PanchTatvaButton onClick={() => navigate('/cart')}>
          Try Again
        </PanchTatvaButton>
        <PanchTatvaButton variant="secondary" onClick={() => navigate('/shop')}>
          Continue Shopping
        </PanchTatvaButton>
      </div>

      {/* Support Section */}
      <div className="mt-12 p-6 bg-cardBg rounded-lg text-center">
        <h3 className="text-lg font-heading text-headingText mb-2">Need Help?</h3>
        <p className="text-sm text-bodyText mb-4">
          If the problem persists, please contact our support team
        </p>
        <div className="space-y-2 text-sm">
          <p className="text-bodyText">
            📧 <strong>Email:</strong>{' '}
            <a href="mailto:support@panch-tatva.com" className="text-secondary hover:underline">
              support@panch-tatva.com
            </a>
          </p>
          <p className="text-bodyText">
            📞 <strong>Phone:</strong>{' '}
            <a href="tel:+919876543210" className="text-secondary hover:underline">
              +91 98765 43210
            </a>
          </p>
          <p className="text-bodyText">
            ⏰ <strong>Available:</strong> Monday - Friday, 9 AM - 6 PM IST
          </p>
        </div>
      </div>
    </div>
  );
}
